var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.03961e-10C0.75454 6.03961e-10 0.550392 0.176875 0.508056 0.410124L0.5 0.5V9.5C0.5 9.77614 0.723858 10 1 10C1.24546 10 1.44961 9.82312 1.49194 9.58988L1.5 9.5V0.5C1.5 0.223858 1.27614 6.03961e-10 1 6.03961e-10ZM8.85355 0.146447C8.67999 -0.0271197 8.41056 -0.046405 8.21569 0.0885911L8.14645 0.146447L3.64645 4.64645C3.47288 4.82001 3.4536 5.08944 3.58859 5.28431L3.64645 5.35355L8.14645 9.85355C8.34171 10.0488 8.65829 10.0488 8.85355 9.85355C9.02712 9.67999 9.0464 9.41056 8.91141 9.21569L8.85355 9.14645L4.70711 5L8.85355 0.853553C9.04882 0.658291 9.04882 0.341709 8.85355 0.146447Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.db4b2e3c83997d8070fd900d3cc39d9c.svg";
export { ForwardRef as ReactComponent };